import type { GlobalChartColorPaletteType } from '../types/types';

export const GLOBAL_CHART_COLOR_PALETTE = {
  turquoise: {
    100: {
      start: '#DCF9F8',
      stop: '#D3F8F6',
    },
    300: {
      start: '#96EDE9',
      stop: '#7CE9E4',
    },
    400: {
      start: '#4FD7D0',
      stop: '#23CDC4',
    },
    500: {
      start: '#3AC2BB',
      stop: '#1BA39C',
    },
    600: {
      start: '#45A09B',
      stop: '#168882',
    },
    700: {
      start: '#418B87',
      stop: '#126E69',
    },
    900: {
      start: '#3A615F',
      stop: '#093937',
    },
  },
  blue: {
    100: {
      start: '#EDF9FD',
      stop: '#E8F8FC',
    },
    300: {
      start: '#9DE1F3',
      stop: '#84DAF0',
    },
    400: {
      start: '#79D7EE',
      stop: '#57CDEB',
    },
    500: {
      start: '#54CCEA',
      stop: '#29BFE5',
    },
    600: {
      start: '#48C0DE',
      stop: '#1AB0D6',
    },
    700: {
      start: '#45ADC8',
      stop: '#1799BA',
    },
    900: {
      start: '#3E7D8E',
      stop: '#0E5D72',
    },
  },
  green: {
    100: {
      start: '#F5FCED',
      stop: '#F3FBE9',
    },
    300: {
      start: '#CEEFA5',
      stop: '#C2EB8F',
    },
    400: {
      start: '#BBE982',
      stop: '#ABE363',
    },
    500: {
      start: '#A8E25E',
      stop: '#92DB36',
    },
    600: {
      start: '#9AD550',
      stop: '#81CB24',
    },
    700: {
      start: '#8BBD4C',
      stop: '#6EAD1F',
    },
    900: {
      start: '#5F783F',
      stop: '#37570F',
    },
  },
  yellow: {
    100: {
      start: '#FDF9D8',
      stop: '#F9EB6C',
    },
    300: {
      start: '#FAEF89',
      stop: '#F9EB6C',
    },
    400: {
      start: '#F9EA61',
      stop: '#F8E53A',
    },
    500: {
      start: '#F5E23A',
      stop: '#F2DB09',
    },
    600: {
      start: '#DCCC39',
      stop: '#D3BF08',
    },
    700: {
      start: '#C1B339',
      stop: '#B1A007',
    },
    900: {
      start: '#918936',
      stop: '#766B04',
    },
  },
  orange: {
    100: {
      start: '#FFF3E7',
      stop: '#FFF0E1',
    },
    300: {
      start: '#FEE1C2',
      stop: '#FED9B4',
    },
    400: {
      start: '#FED4AA',
      stop: '#FEC995',
    },
    500: {
      start: '#FDC083',
      stop: '#FDB064',
    },
    600: {
      start: '#FDB56E',
      stop: '#FDA34A',
    },
    700: {
      start: '#FDA955',
      stop: '#FD942B',
    },
    900: {
      start: '#DD8935',
      stop: '#D46B02',
    },
  },
  red: {
    100: {
      start: '#FFEAEA',
      stop: '#FFE5E5',
    },
    300: {
      start: '#FFC1C1',
      stop: '#FFB2B2',
    },
    400: {
      start: '#FFADAD',
      stop: '#FF9999',
    },
    500: {
      start: '#FF9999',
      stop: '#FF8080',
    },
    600: {
      start: '#FF8585',
      stop: '#FF6666',
    },
    700: {
      start: '#FF5050',
      stop: '#FF2424',
    },
    900: {
      start: '#C63333',
      stop: '#B80000',
    },
  },
  purple: {
    100: {
      start: '#FFEAF6',
      stop: '#FFE5F4',
    },
    300: {
      start: '#FFC1E5',
      stop: '#FFB2DE',
    },
    400: {
      start: '#FFADDC',
      stop: '#FF99D3',
    },
    500: {
      start: '#FF99D3',
      stop: '#FF80C8',
    },
    600: {
      start: '#FF85CA',
      stop: '#FF66BD',
    },
    700: {
      start: '#FF6CBF',
      stop: '#FF47AF',
    },
    900: {
      start: '#DA3391',
      stop: '#D10076',
    },
  },
  gray: {
    100: {
      start: '#F8F9FC',
      stop: '#F0F2F5',
    },
    300: {
      start: '#EEF3FA',
      stop: '#E2E6EC',
    },
    400: {
      start: '#CFD5E3',
      stop: '#C0C5CF',
    },
    500: {
      start: '#B5BECD',
      stop: '#949BA8',
    },
    600: {
      start: '#929BAE',
      stop: '#7B8393',
    },
    700: {
      start: '#677085',
      stop: '#4B505C',
    },
    900: {
      start: '#525151',
      stop: '#232323',
    },
  },
} satisfies GlobalChartColorPaletteType;
